export const LINKS = {
  LOCAL_ZEN: 'https://localzen.com/',
};
